// Minimal grayscale spinner. No color, no animated dots — just a thin rotating
// arc that signals "working" without competing with the deliverable previews.

interface SpinnerProps {
  size?: number;
  className?: string;
  label?: string;
}

export function Spinner({ size = 16, className = '', label }: SpinnerProps) {
  const px = `${size}px`;
  return (
    <span
      role="status"
      aria-label={label ?? 'Loading'}
      className={`inline-flex items-center ${className}`}
    >
      <svg
        width={px}
        height={px}
        viewBox="0 0 24 24"
        fill="none"
        className="animate-spin text-zinc-400"
        aria-hidden="true"
      >
        <circle
          cx="12"
          cy="12"
          r="9"
          stroke="currentColor"
          strokeWidth="2"
          opacity="0.25"
        />
        <path
          d="M21 12a9 9 0 0 0-9-9"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
      {label ? (
        <span className="ml-2 text-sm text-zinc-400">{label}</span>
      ) : null}
    </span>
  );
}
